export default __webpack_public_path__ + "static/media/logo-title.605ee539.png";